import { render } from "./CdaPage.vue?vue&type=template&id=4d1c5d2c"
import script from "./CdaPage.vue?vue&type=script&lang=js"
export * from "./CdaPage.vue?vue&type=script&lang=js"

import "./CdaPage.vue?vue&type=style&index=0&id=4d1c5d2c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__